import {Line} from 'react-chartjs-2';

export const SolidLineChart = ({data, legend}: any) => {
  return <Line className="line-chart" data={data as any}></Line>;
};
